import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateNewCondition } from "../../models/migrationrules/CreateNewCondition";
import { UpdateCondition } from "../../models/migrationrules/UpdateCondition";

const RESOURCE_NAME = "conditions";

const getAll = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}`, requestConfig());
};

const createCondition = (model: CreateNewCondition) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, model, requestConfig());
};

const updateCondition = (model: UpdateCondition) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${model.id}`, model, requestConfig());
};

const deleteCondition = (id: number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
};

const ConditionService = {
  getAll,
  createCondition,
  updateCondition,
  deleteCondition,
};
export default ConditionService;
